import React from 'react'
import Form from "../../components/userRegisterComponents/Form"
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const UserRegistrationForm = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Transactions'));

    return <Form />
}

export default UserRegistrationForm